import React from 'react'
import { Field } from 'redux-form'
import { TextField } from 'redux-form-material-ui'

const IrisTextField = props => (
  <Field className="form-input-field" component={TextField} {...props} />
)

export default IrisTextField
